<!-- 执法单位 行政区域 从表 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj="{}"
      :option="{}"
      :colObj="{
        opId: '20021',
        name: '动态扩展列设置明细',
        parentId: 'ID',
        parentName: '动态扩展列设置',
        parentPath: '/system/extCol',
        dataClass: 2,
        col: [],
        addParams:{
          EXT_ID:$route.query.EXT_ID
        }
      }"
      :filterObj="{
        EXT_ID:$route.query.EXT_ID
      }"
    >
    </Table>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablecSon";
export default {
  components: {
    Table,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {},
  methods: {
  },
  created() {},
  activated() {
    this.isTree = this.$route.query.IS_TREE == 1;
    if (this.firstEnter) {
      this.firstEnter = false;
    } else {
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
